import { render, staticRenderFns } from "./ScreenEcocardiodopplerFetal.vue?vue&type=template&id=34bbcd2d&scoped=true&"
import script from "./ScreenEcocardiodopplerFetal.vue?vue&type=script&lang=js&"
export * from "./ScreenEcocardiodopplerFetal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenEcocardiodopplerFetal.vue?vue&type=style&index=0&id=34bbcd2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbcd2d",
  null
  
)

export default component.exports